/***
 * rem适配
 */
function remAdaptation () {
  const htmlNode = document.documentElement
  htmlNode.style.fontSize = document.documentElement.clientWidth / 23.4375 + 'px'
}

window.addEventListener('resize', remAdaptation)

remAdaptation()





// WEBPACK FOOTER //
// ./src/utils/rem.js